import clsx from 'clsx';
import { cloneElement } from 'react';
import { factory } from '../../../../factory/factory.utils.mjs';
import { usePopoverContext } from '../Popover.context.mjs';
import { isElement } from './PopoverTarget.utils.mjs';
import { useMergedRef } from './use-merged-ref.mjs';

const PopoverTarget = factory((props, ref) => {
  const { children, refProp = "ref", popupType = "dialog", ...rest } = props;
  if (!isElement(children)) {
    throw new Error(
      "Popover.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
    );
  }
  const forwardedProps = rest;
  const ctx = usePopoverContext();
  const targetRef = useMergedRef(ctx.reference, children.ref, ref);
  const accessibleProps = ctx.withRoles ? {
    "aria-haspopup": popupType,
    "aria-expanded": ctx.opened,
    "aria-controls": ctx.getDropdownId(),
    id: ctx.getTargetId()
  } : {};
  return cloneElement(children, {
    ...forwardedProps,
    ...accessibleProps,
    ...ctx.targetProps,
    className: clsx(ctx.targetProps.className, forwardedProps.className, children.props.className, "kohler-popover-target"),
    [refProp]: targetRef,
    ...!ctx.controlled ? { onClick: ctx.onToggle } : null
  });
});

export { PopoverTarget };
